import type { Lucid } from '../../types/types';

export type WithDiscoveryPagesByTypeProps = {
  /** The type of discovery page that should be displayed */
  discoveryTypeFilter?: string;
  /** The id of the discovery page the additional resources are being displayed on */
  excludeId?: string;
  /** The current language being displayed */
  languageKey: Lucid.I18n.LanguagesShortCode;
};

type WithDiscoveryPagesByType = (
  discovery: Lucid.Directus.Generated.Discovery[],
  options: WithDiscoveryPagesByTypeProps,
) => Lucid.Directus.Generated.Discovery[];

const withDiscoveryPagesByType: WithDiscoveryPagesByType = (
  discovery,
  { discoveryTypeFilter, excludeId, languageKey },
) =>
  discovery.reduce<Lucid.Directus.Generated.Discovery[]>((previous, item) => {
    const translation = item.translations?.find(t => t.languages_code?.short_code === languageKey);

    if (!!translation && item.discovery_type?.id === discoveryTypeFilter && item.id !== excludeId) {
      return [...previous, { ...item, translations: [translation] }];
    }

    return previous;
  }, []);

export default withDiscoveryPagesByType;
